import React, { useState } from 'react';
import { Line } from 'react-chartjs-2';

interface PerformanceRecord {
  c4: string;   // 날짜 (YYYY-MM-DD)
  c26: number;  // 매출액
}

interface Props {
  records: PerformanceRecord[];
  colors: string[];
}

const SalesDateBarChart: React.FC<Props> = ({ records, colors }) => {
  const [mode, setMode] = useState<'day' | 'month'>('day');

  // 날짜 파싱 및 그룹핑
  const group = records.reduce((acc, rec) => {
    if (!rec.c4) return acc;
    let key = '';
    if (mode === 'day') {
      key = rec.c4.slice(0, 10); // YYYY-MM-DD
    } else {
      key = rec.c4.slice(0, 7);  // YYYY-MM
    }
    acc[key] = (acc[key] || 0) + rec.c26;
    return acc;
  }, {} as Record<string, number>);

  // x축 정렬
  const labels = Object.keys(group).sort();
  const values = labels.map(label => group[label]);

  return (
    <div>
      <div style={{ marginBottom: 12, display: 'flex', gap: 8 }}>
        <button
          onClick={() => setMode('day')}
          style={{
            background: mode === 'day' ? '#202A5B' : '#eee',
            color: mode === 'day' ? '#fff' : '#333',
            border: 'none',
            borderRadius: 4,
            padding: '4px 12px',
            fontWeight: 'bold',
            cursor: 'pointer',
            boxShadow: mode === 'day' ? '0 2px 8px #202A5B22' : 'none'
          }}
        >
          일별
        </button>
        <button
          onClick={() => setMode('month')}
          style={{
            background: mode === 'month' ? '#202A5B' : '#eee',
            color: mode === 'month' ? '#fff' : '#333',
            border: 'none',
            borderRadius: 4,
            padding: '4px 12px',
            fontWeight: 'bold',
            cursor: 'pointer',
            boxShadow: mode === 'month' ? '0 2px 8px #202A5B22' : 'none'
          }}
        >
          월별
        </button>
      </div>
      <div className="chart line-chart">
        <Line
          data={{
            labels,
            datasets: [
              {
                label: '매출액',
                data: values,
                borderColor: colors[0] || '#8884d8',
                backgroundColor: colors[0] || '#8884d8',
                fill: false,
                tension: 0.2,
                pointRadius: 3,
                pointHoverRadius: 6,
              },
            ],
          }}
          options={{
            responsive: true,
            maintainAspectRatio: false,
            plugins: {
              legend: { display: false },
              title: { display: false },
              tooltip: {
                callbacks: {
                  label: function(context) {
                    const value = context.parsed.y;
                    return `매출액: ${value.toLocaleString()}원`;
                  }
                }
              }
            },
            scales: {
              y: {
                ticks: {
                  callback: function(value) {
                    return value.toLocaleString();
                  }
                }
              }
            }
          }}
          height={300}
        />
      </div>
    </div>
  );
};

export default SalesDateBarChart; 